module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-500-[36]279.298bceb.woff2";